module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-2560-92bff23f98cff8b94bfa82252efbaff5.webp";